// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_row {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #DCDCDC;
    height: 45px;
}

tr.Table_row:last-child {
    border-bottom: none;
}

.Table_values {
    font-family: "Jost";
    font-size: 14px;
    font-weight: 500;
    padding-left: 20px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.Table_values_link {
    text-decoration: underline;
    cursor: pointer;
}

.Table_values_rightarrow {
    vertical-align: middle;
    margin-left: 7px;
}

.Table_values_ellipsis {
    height: 3.66px;
    width: 18.3px;
}

#tablefooter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 74px;
    background-color: #FAF6F2;

    margin-top: 30px;
    padding-left: 15px;
    padding-right: 33px;
}

.tablefooter_col {
    display: flex;
    align-items: center;
}

.tablefooter_col#col1 {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 600;
}

.tablefooter_col#col2 {
    display: flex;
    flex-direction: row;
    align-items: center;
}

#col2_lefttext {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 600;
    opacity: 50%;
}

.col2_dropdowncontainer {
    position: relative;
}

.col2_dropdownselected {
    box-sizing: border-box;
    height: 35.58px;
    width: 49.81px;
    background-color: #FFFFFF;

    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 5px;
    color: black;
    
}

#dropdown-pagenumber {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 600;
    color: black;

}

#dropdown-arrow {
    width: 9px;
}

.col2_dropdownoptions {
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    height: 50px;
    width: 49.81px;
    overflow-y: scroll;

    left: 10px;
    margin-top: 5px;
    padding-left: 14px;
    color: black;
    background-color: #FFF;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.089);
}

.col2_dropdownoptions.show::-webkit-scrollbar {
    width: 5px;
}

.col2_dropdownoptions.show::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.col2_dropdownoptions.show::-webkit-scrollbar-thumb {
    background: #888;
}

.col2_dropdownoptions.show::-webkit-scrollbar-thumb:hover {
    background: #555;
}

#dropdownoption {
    width: 15px;
    height: 20px;

    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;

    margin-top: 5px;
}

#col2_righttext {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 700;

    margin-left: 10px;
}

.tablefooter_button {
    background-color: #FFF;
    height: 35.58px;
    width: 99.62px;

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tablefooter_button-hide { display: none; }

.tablefooter_buttonicon {
    height: 10px;
}

.tablefooter_buttonicon#leftarrow {
    transform: scaleX(-1);
}

.tablefooter_buttontitle {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 600;
}

.tablefooter_buttontitle#previous {
    margin-left: 5px;
}

.tablefooter_button#button2 {
    margin-left: 10px;
}

.tablefooter_buttonicon#rightarrow {
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/screens/Projects/Analysis/Pagination/Pagination.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;;IAElB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;;IAEzB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,yBAAyB;;IAEzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,kBAAkB;;IAElB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;;IAEhB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,2BAA2B,aAAa,EAAE;;AAE1C;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".Table_row {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #DCDCDC;\n    height: 45px;\n}\n\ntr.Table_row:last-child {\n    border-bottom: none;\n}\n\n.Table_values {\n    font-family: \"Jost\";\n    font-size: 14px;\n    font-weight: 500;\n    padding-left: 20px;\n\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.Table_values_link {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.Table_values_rightarrow {\n    vertical-align: middle;\n    margin-left: 7px;\n}\n\n.Table_values_ellipsis {\n    height: 3.66px;\n    width: 18.3px;\n}\n\n#tablefooter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 74px;\n    background-color: #FAF6F2;\n\n    margin-top: 30px;\n    padding-left: 15px;\n    padding-right: 33px;\n}\n\n.tablefooter_col {\n    display: flex;\n    align-items: center;\n}\n\n.tablefooter_col#col1 {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.tablefooter_col#col2 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n#col2_lefttext {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 600;\n    opacity: 50%;\n}\n\n.col2_dropdowncontainer {\n    position: relative;\n}\n\n.col2_dropdownselected {\n    box-sizing: border-box;\n    height: 35.58px;\n    width: 49.81px;\n    background-color: #FFFFFF;\n\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    padding: 5px;\n    color: black;\n    \n}\n\n#dropdown-pagenumber {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 600;\n    color: black;\n\n}\n\n#dropdown-arrow {\n    width: 9px;\n}\n\n.col2_dropdownoptions {\n    box-sizing: border-box;\n    position: absolute;\n    z-index: 1;\n    height: 50px;\n    width: 49.81px;\n    overflow-y: scroll;\n\n    left: 10px;\n    margin-top: 5px;\n    padding-left: 14px;\n    color: black;\n    background-color: #FFF;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.089);\n}\n\n.col2_dropdownoptions.show::-webkit-scrollbar {\n    width: 5px;\n}\n\n.col2_dropdownoptions.show::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.col2_dropdownoptions.show::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n.col2_dropdownoptions.show::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n#dropdownoption {\n    width: 15px;\n    height: 20px;\n\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n\n    margin-top: 5px;\n}\n\n#col2_righttext {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 700;\n\n    margin-left: 10px;\n}\n\n.tablefooter_button {\n    background-color: #FFF;\n    height: 35.58px;\n    width: 99.62px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.tablefooter_button-hide { display: none; }\n\n.tablefooter_buttonicon {\n    height: 10px;\n}\n\n.tablefooter_buttonicon#leftarrow {\n    transform: scaleX(-1);\n}\n\n.tablefooter_buttontitle {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.tablefooter_buttontitle#previous {\n    margin-left: 5px;\n}\n\n.tablefooter_button#button2 {\n    margin-left: 10px;\n}\n\n.tablefooter_buttonicon#rightarrow {\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
